import { Button, Grid, Typography } from "@mui/material";

const DocumentPagination = ({ page, hasNextPage, loading, onPageChange }) => {
  if (page === 1 && !hasNextPage) {
    return null;
  }

  return (
    <Grid
      item
      xs={12}
      component="nav"
      aria-label="Paginación de documentos"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        width: "100%",
        marginBottom: 3,
      }}
    >
      <Button
        variant="outlined"
        disabled={loading || page === 1}
        onClick={() => onPageChange(page - 1)}
      >
        Anterior
      </Button>
      <Typography aria-live="polite" sx={{ fontFamily: "robotoMedium" }}>
        Página {page}
      </Typography>
      <Button
        variant="outlined"
        disabled={loading || !hasNextPage}
        onClick={() => onPageChange(page + 1)}
      >
        Siguiente
      </Button>
    </Grid>
  );
};

export default DocumentPagination;
